<template>
  <div class="title-container row m-top">
    <h2 class="title h1 h5-xs">{{ text }}</h2>
  </div>
</template>

<script>
export default {
  name: "TitleComponent",
  props: {
    text: {
      type: String,
      default: () => {
        return "";
      },
    },
  },
  methods: {},
  data() {
    return {};
  },
};
</script>

<style scoped>
.title-container {
  clear: both;
}
.m-top {
  margin-top: 20px !important;
}
.row {
  margin-right: -15px;
  margin-left: -15px;
}
h1,
.h1,
h2,
.h2,
h3,
.h3,
h4,
.h4,
h5,
.h5,
h6,
.h6 {
  text-transform: uppercase;
  font-weight: bold;
  font-family: "Open Sans";
  letter-spacing: 2px;
}
.title,
.subtitle {
  margin: 10px 0 30px 0;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
}
.title {
  font-size: 28px;
}
.title:before,
.subtitle:before {
  margin-right: 10px;
}
.title:after,
.title:before,
.subtitle:after,
.subtitle:before {
  flex-grow: 1;
  height: 1px;
  content: "\a0";
  background-color: #7D7D7D;
  position: relative;
  top: 0.5em;
}
.title:after,
.subtitle:after {
  margin-left: 10px;
}
.row {
  margin-left: 0;
  margin-right: 0;
}
@media only screen and (max-width: 747px) {
  .h5-xs {
    font-size: 14px;
  }
  .title {
    font-size: 18px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/TitleComponent.vue